import { Component } from '@angular/core';

@Component({
  selector   : 'app-loader-logo',
  templateUrl: './loader-logo.component.html',
  styleUrls  : ['./loader-logo.component.scss']
})
export class LoaderLogoComponent {

}
